import { Module } from '@nu-art/ts-common';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
import { HCSPermissionKeys, HCSUIPermissionKeys } from '@app/hcs-shared';
class ModuleFE_HCSPermissions_Class extends Module {
    permissions;
    constructor() {
        super();
        this.permissions = {
            ui: PermissionKey_FE.generatePermissionKeysByLevels(HCSUIPermissionKeys),
            collection: PermissionKey_FE.generatePermissionKeysByLevels(HCSPermissionKeys),
        };
    }
}
export const ModuleFE_HCSPermissions = new ModuleFE_HCSPermissions_Class();
//# sourceMappingURL=ModuleFE_HCSPermissions.js.map